import {AfterViewInit, Component, computed, inject, model, viewChild} from '@angular/core';
import {SelectComponent} from '../../../../shared/components/select/select.component';
import {ButtonComponent} from '../../../../shared/components/button/button.component';
import {LookupTabBase} from '../../lookup-tab-base';
import {Text} from '../../../../shared/components/text/text';
import {FormsModule} from '@angular/forms';
import {Form} from '../../../../shared/components/form/form';
import {PostHogService} from '../../../../shared/services/posthog.service';

@Component({
  selector: 'app-lookup-by-manual',
  imports: [
    SelectComponent,
    ButtonComponent,
    Text,
    FormsModule,
    Form
  ],
  templateUrl: './lookup-by-manual.html',
  styleUrl: './lookup-by-manual.css'
})
export class LookupByManual extends LookupTabBase implements AfterViewInit {
  private posthogService = inject(PostHogService);
  value = model<string>('')
  type = model<'rawsize' | 'part_number'>('rawsize');
  options = [{label: 'Rawsize', value: 'rawsize'}, {label: 'Item Number', value: 'part_number'}]

  manualLookup = viewChild.required<Text>('manualLookup');

  ngAfterViewInit() {
    this.manualLookup().focus(100);
  }

  isValid = computed(() => this.value().trim().length);
  inputmode = computed(() => this.type() === 'rawsize' ? 'numeric' : 'text');

  submit() {
    if (this.isValid()) {
      this.posthogService.posthog.capture('tire_search_by_manual', {
        search_type: this.type(),
        search_value: this.value().trim(),
      });
      this.search.emit({
        rawsize: this.type() === 'rawsize' ? this.value() : undefined,
        part_number: this.type() === 'part_number' ? this.value() : undefined,
      });
    }
  }
}
